export enum ssuOriginOfTransactionEnum {
    null = 0,
    mediBucks = 1,
    NTA = 2,
}

export namespace ssuOriginOfTransactionEnum {
    export function values() {
        return Object.keys(ssuOriginOfTransactionEnum).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}
